import React from 'react'
import { Theme, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Grid, makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import close from '../assets/images/colosePopup.svg'

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: 0,
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

interface ChartTooltipModalProps {
  open?: any
  setOpen?: any
  handleClose?: any
}
const useStyles = makeStyles({
  content: {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: 3,
    maxWidth: 820,
    width: '100%',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    padding: '4px 24px 24px 24px',
  },
  title: {
    color: '#181818',
    fontFamily: 'Inter, sans-serif',
    fontSize: 24,
    lineHeight: '28px',
    fontWeight: 600,
  },
  subTitle: {
    color: '#5E5E5E',
    fontFamily: 'Inter, sans-serif',
    fontSize: 24,
    lineHeight: '28px',
    fontWeight: 400,
  },
  detailContent: {
    marginBottom: 12,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 12,
    marginBottom: 16,
    borderBottom: '1px solid #DFE4EB',
    '& input': {
      width: 36,
      height: 36,
      borderRadius: 999,
      background: '#F2F2F2',
      boxSizing: 'border-box',
    },
  },
  body: {
    overflowY: 'auto',
    paddingRight: 4,
  },
  typeHead: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 700,
    color: '#1B3963',
  },
  typeDetail: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '22px',
    color: '#475569',
    '& b': {
      fontWeight: 700,
      color: '#1B3963',
    },
  },
})

const BehaviouralTooltipModal = ({
  open,
  setOpen,
  handleClose,
}: ChartTooltipModalProps) => {
  const classes = useStyles()
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth={false}
        PaperProps={{ style: { maxWidth: 820, width: '100%' } }}
      >
        <DialogContent>
          <div className={classes.content}>
            {!isMobile && (
              <div className={classes.header}>
                <div>
                  <span className={classes.title}>Behavioural Panel </span>
                  <span className={classes.subTitle}>
                    (Street Perception & Investor Confidence Measures)
                  </span>
                </div>
                <input
                  type="image"
                  onClick={() => handleClose()}
                  src={close}
                  alt="closeBtn"
                />
              </div>
            )}

            {isMobile && (
              <>
                <div className={classes.header} style={{ marginBottom: 5 }}>
                  <div>
                    <span className={classes.title}>Behavioural Panel </span>
                    <span className={classes.subTitle}>
                      (Street Perception & Investor Confidence Measures)
                    </span>
                  </div>
                  <input
                    type="image"
                    onClick={() => handleClose()}
                    src={close}
                    alt="closeBtn"
                  />
                </div>
              </>
            )}
            <div className={classes.body}>
              <div className={classes.detailContent}>
                <span className={classes.typeHead}>Behavioural Analysis: </span>
                <span className={classes.typeDetail}>
                  Perception is reality, when looking at risk it is important to
                  track and understand if other market participants have pockets
                  of better insights and are reflecting those into the outlook
                  of the company. This can give a strong early warning of
                  behaviour change in the investor and analyst community towards
                  a target company. These charts in this panel are based around
                  asking the Analyst and Investor community what they think
                  about the company and identifying if they are changing their
                  behaviours, conviction or perceptions. Just like you would
                  make calls to your market “friends”, we make those calls on
                  your behalf, through the data of 100’s of thousands of
                  Analysts and Investors. We will speak to the data of more than
                  130,000 Global Analysts and 270,000 Active Investors.
                </span>
              </div>
              <div className={classes.detailContent}>
                <span className={classes.typeHead}>Earnings Risk: </span>
                <span className={classes.typeDetail}>
                  We identify leading Analysts which we call “smart consensus” a
                  group of 3 or more Analysts who have a strong track record
                  above 70% accuracy in forecasting the earnings of the company.
                  We display this forward looking on either an annual or interim
                  (quarterly or semi-annual basis) against the market consensus.
                  This is a good way to identify if the smart part of the
                  Analyst community is forecasting potential earnings weakness
                </span>
              </div>
              <div className={classes.detailContent}>
                <span className={classes.typeHead}>
                  Equity & Bond Conviction:{' '}
                </span>
                <span className={classes.typeDetail}>
                  These charts look at the behaviour of active investors, on the
                  equity side, an index is built to track those active investors
                  who have over allocated capital to the company versus their
                  benchmark. If this declines it could signal that these over
                  convicted investors are reducing their confidence in the
                  company and pulling back their capital. On the bond side we
                  track the top 25 bond holders across the curve, to give you a
                  view of investor confidence in allocating capital to the
                  companies bonds.
                </span>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(BehaviouralTooltipModal)
